var map = {
	"./fonts/nexa_bold.otf": "b885",
	"./fonts/nexa_regular.otf": "142d",
	"./png/Logo_Blue.png": "822f",
	"./png/Logo_Orange.png": "5098",
	"./png/Logo_White.png": "5ec3",
	"./png/MockUp_Cards.png": "b969",
	"./png/logoh.png": "8f60",
	"./png/saude_sams_quadros.png": "5c25",
	"./svg/Analises.svg": "394a",
	"./svg/BG_Card.svg": "e198",
	"./svg/BG_Landing.svg": "a95c",
	"./svg/BG_Location.svg": "aad4",
	"./svg/Cardiologia.svg": "353a",
	"./svg/localizacao.svg": "12e4",
	"./svg/logo-unilabs.svg": "921e",
	"./svg/lungs.svg": "a117"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";